export default __webpack_public_path__ + "pgnv-assets/1d58266f7d8ddd3529de7250657bf356.png";